import { render, staticRenderFns } from "./CompanyAssetType.vue?vue&type=template&id=6bf7c5ef&"
import script from "./CompanyAssetType.vue?vue&type=script&lang=js&"
export * from "./CompanyAssetType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports